/* eslint-disable default-case, no-param-reassign */
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import produce from 'immer';
import { actions, DataExtractionDefinitionsActions } from '.';
import { DataExtractionDefinitionsState } from './types';

const initialState: DataExtractionDefinitionsState = {
  detectedObjectTypes: undefined,
};

const reducer: Reducer<DataExtractionDefinitionsState, DataExtractionDefinitionsActions> = (
  state = initialState,
  action,
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case getType(actions.setDataExtractionDefinitionsActionTypesAction): {
        draft.detectedObjectTypes = action.payload;
        break;
      }
    }

    return draft as DataExtractionDefinitionsState;
  });

export default reducer;
